<template>
  <div>
    <b-container fluid style="min-height: calc(40vh)" class="px-0">
      <b-card id="card-principal" class="mb-0 pb-0">
        <template #header>
          <i class="fas fa-edit"></i>
          <strong>{{$lang.PCI.PdrBonusPayment.PrincipalTitle}}</strong>
        </template>
        <b-row>
          <ag-grid-vue style="width: 100%; height: calc(60vh)" id="obras-grid"
                  class="ag-theme-alpine"
                  :suppressRowClickSelection="true"
                  rowSelection="multiple"
                  :getLocaleText="localeTextFunc"
                  :gridOptions="obrasDataGridOptions"
                  :columnTypes="columnTypes"
                  :columnDefs="obrasColumnDefs"
                  :defaultColDef="defaultColumnDef"
                  :rowData="obrasRowData"
                  @gridReady="onGridReady"
                  @filterChanged="onFilterChange"
                  @cellFocused="setPrintId"
                  @cellDoubleClicked="printPDF"
                  >
          </ag-grid-vue>
        </b-row>
        <b-row style="display: flow-root;">
          <b-col cols="1">
            <span style="font-size: small;font-weight: bold;">Total: </span>
            {{ totalWorkRows }}
          </b-col>
        </b-row>
      </b-card>
    </b-container>
    <div id="div-buttons">
      <button type="button" class="btn btn-third btn-sm" v-show="this.obrasRowData.length > 0" v-on:click="printPDF()" v-b-tooltip.hover><i class="fa fa-print"></i> {{$lang.PCI.PdrBonusPayment.ButtonPrint}}</button>
      <button type="button" class="btn btn-third btn-sm" v-show="this.obrasRowData.length > 0" v-on:click="administrativeDirectorFinish()" v-b-tooltip.hover><i class="fa fa-check"></i> {{$lang.PCI.PdrBonusPayment.ButtonFinish}}</button>
    </div>

    <b-modal ref="pdrPaymentModal"
             id="pdrPaymentModal"
             size="lg"
             :no-close-on-esc="true"
             :hide-footer="true"
             scrollable>
      <template #modal-header>
        <div class="d-flex align-items-center col-12">
          <img src="https://static.zopone.com.br/img/logotipo/header/zopone.png" style="width: 45px" />
          <span class="modalTitle ml-auto">
            {{'Pedidos Gerados'}}
          </span>
          <button class="close" @click="$refs.pdrPaymentModal.hide()">x</button>
        </div>
      </template>
      <b-alert v-if="exceptionGenetation" variant="danger">{{ exceptionGenetation }}</b-alert>
      <b-table v-else :fields="membersColumDefs" :items="generatedMembers"></b-table>
    </b-modal>
  </div>
</template>

<script>
import PdrBonusPayment from './pdrbonuspayment.js'
export default PdrBonusPayment
</script>

<style scoped>
  #div-buttons {
    margin-top: 20px;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/pdrbonuspayment/pdrbonuspayment.vue